export const GET_ALL_FEEDBACK = 'GET_ALL_FEEDBACK';
export const GET_VENDOR_TABLE_DATA = 'GET_VENDOR_TABLE_DATA';
export const GET_OVERALL_RATING_GRAPH = 'GET_OVERALL_RATING_GRAPH';
export const GET_QUESTIONS_TABLE = 'GET_QUESTIONS_TABLE';
export const GET_QUESTIONS_GRAPH = 'GET_QUESTIONS_GRAPH';
export const GET_RESPONSE_TRENDS = 'GET_RESPONSE_TRENDS';
